import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

export const Permission = ({ permission }) => {
    const permissions = useSelector(({ permissions: p }) => p);
    return <>{!permissions.includes(permission) && <Redirect to="/dashboard" />}</>;
};
